module.exports = __webpack_public_path__ + "ced53c1e5e68c2b3197dd61fbfd292cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-768.jpg
// module id = 416
// module chunks = 0